import { useLazyQuery, useQuery } from "@apollo/client";
import { JOB_TITLE } from "../job-title.queries";
import { JobTitleQuery, JobTitleQueryVariables } from "../../../__generated__/JobTitleQuery";

export const useJobTitle = (id: number) => {
  return useQuery<JobTitleQuery, JobTitleQueryVariables>(JOB_TITLE, { variables: { id } });
};

export const useLazyJobTitle = () => {
  return useLazyQuery<JobTitleQuery, JobTitleQueryVariables>(JOB_TITLE);
};
